export default "__VITE_ASSET__p4ZtiDD7__"